<template>
  <aside class="menu">
    <p class="menu-label">{{ $texts('user_menu', 'Benutzermenü') }}</p>
    <ul class="menu-list">
      <li>
        <VuepalLink to="/user/login" active-class="is-active">{{
          $texts('login', 'Anmelden')
        }}</VuepalLink>
      </li>
      <li>
        <VuepalLink to="/user/register" active-class="is-active">
          {{ $texts('register', 'Registrieren') }}</VuepalLink
        >
      </li>
      <li>
        <VuepalLink to="/user/reset" active-class="is-active">{{
          $texts('new_password', 'Passwort vergessen')
        }}</VuepalLink>
      </li>
    </ul>
  </aside>
</template>

<script setup lang="ts">
const { $texts } = useNuxtApp()
</script>
